const SOLES = 'SOLES'
const DOLARES = 'DOLARES'
const EUROS = 'EUROS'

const __dictionary = {
  [SOLES]: {
    id: [SOLES],
    nombre: 'SOLES',
    signo: 'S/ .',
    nombreCompleto: 'SOLES'
  },
  [DOLARES]: {
    id: [DOLARES],
    nombre: 'DÓLARES',
    signo: 'USD',
    nombreCompleto: 'DOLARES AMERICANOS'
  },
  [EUROS]: {
    id: [EUROS],
    nombre: 'EUROS',
    signo: 'EUR',
    nombreCompleto: 'EUROS'
  }
}

const __array = [__dictionary[SOLES], __dictionary[DOLARES], __dictionary[EUROS]]

export default Object.freeze({
  SOLES,
  DOLARES,
  EUROS,
  __dictionary,
  __array
})
